.surface {
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-12);
  box-sizing: border-box;
  /* No margin — parent controls spacing between Surfaces via gap/margin. */
}

/* tone — maps to the three Figma background semantic tokens */
.tone-primary   { background: var(--bg-primary); }
.tone-secondary { background: var(--bg-secondary); }
.tone-tertiary  { background: var(--bg-tertiary); }

/* padding */
.padding-sm { padding: var(--spacing-8); }
.padding-md { padding: var(--spacing-12); }
.padding-lg { padding: var(--spacing-16); }

/* interactive — hover state + pointer cursor. The hover steps the tone
 * up one level (primary → secondary, secondary → tertiary) so the motion
 * is subtle and doesn't fight the base Surface tone. */
.interactive {
  cursor: pointer;
  transition:
    background-color var(--motion-duration-fast) ease,
    border-color var(--motion-duration-fast) ease;
}

.interactive.tone-primary:hover   { background: var(--bg-secondary); }
.interactive.tone-secondary:hover { background: var(--bg-tertiary); }
/* tertiary has no higher tone level to step up to — hover only changes the
 * cursor (via .interactive). If design requires a visible hover affordance
 * for interactive tertiary surfaces, a dedicated token or colour tweak is
 * needed. The declarations below match the base values intentionally. */
.interactive.tone-tertiary:hover  { background: var(--bg-tertiary); border-color: var(--stroke-neutral); }

/* Surface uses a 2px brand-coloured outline ring (distinct from Button /
 * IconButton which use `box-shadow: 0 0 0 1px var(--text-primary)`).
 * The distinction is intentional: interactive cards (card-hover affordance)
 * vs. controls (button-click affordance) should be visually distinguishable
 * for keyboard users. If design ever unifies them, align to the box-shadow
 * pattern used by Button/IconButton and document the change here. */
.interactive:focus-visible {
  outline: 2px solid var(--brand);
  outline-offset: 2px;
}
